import { render } from "./ModalScheduleRecurrenceSessions.vue?vue&type=template&id=5c773f48"
import script from "./ModalScheduleRecurrenceSessions.vue?vue&type=script&lang=js"
export * from "./ModalScheduleRecurrenceSessions.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__